import { render } from "./Receipt.vue?vue&type=template&id=14d1ba21&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"

import "./Receipt.vue?vue&type=style&index=0&id=14d1ba21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14d1ba21"

export default script